import { Button } from '@components/index'
import React from 'react'
interface IProps {
    code: number
    codeMsg: string
    message: string
    reset?: () => void
}

export default function ErrorTemplate(props: IProps): JSX.Element {

    React.useEffect(() => {
        init()
    }, [])

    function init(): void {
        const stackContainer = document.querySelector('.stack-container') as HTMLElement
        const cardNodes = document.querySelectorAll('.card-container')
        const perspecNodes = document.querySelectorAll('.perspec')
        const perspec = document.querySelector('.perspec')
        const card = document.querySelector('.card')

        let counter = stackContainer?.children?.length || 0

        //function to generate random number
        function randomIntFromInterval(min: number, max: number): number {
            return Math.floor(Math.random() * (max - min + 1) + min)
        }

        //after tilt animation, fire the explode animation
        card?.addEventListener('animationend', function () {
            perspecNodes.forEach(function (elem) {
                elem.classList.add('explode')
            })
        })

        //after explode animation do a bunch of stuff
        perspec?.addEventListener('animationend', function (e) {
            if ((e as AnimationEvent).animationName === 'explode') {
                cardNodes.forEach(function (elem) {
                    const parsed = elem as HTMLElement
                    //add hover animation class
                    parsed.classList.add('pokeup')

                    //add event listner to throw card on click
                    parsed.addEventListener('click', function () {
                        const updown = [800, -800]
                        const randomY = updown[Math.floor(Math.random() * updown.length)]
                        const randomX = Math.floor(Math.random() * 1000) - 1000

                        parsed.style.transform = `translate(${randomX}px, ${randomY}px) rotate(-540deg)`
                        parsed.style.transition = 'transform 1s ease, opacity 2s'
                        parsed.style.opacity = '0'
                        counter--
                        if (counter === 0 && stackContainer) {
                            stackContainer.style.width = '0'
                            stackContainer.style.height = '0'
                        }
                    })

                    //generate random number of lines of code between 4 and 10 and add to each card
                    const numLines = randomIntFromInterval(5, 10)

                    //loop through the lines and add them to the DOM
                    for (let index = 0; index < numLines; index++) {
                        const lineLength = randomIntFromInterval(25, 97)
                        const node = document.createElement('li')
                        node.classList.add('node-' + index)
                        parsed.querySelector('.code ul')?.appendChild(node)?.setAttribute('style', '--linelength: ' + lineLength + '%;')

                        //draw lines of code 1 by 1
                        if (index == 0) {
                            parsed.querySelector('.code ul .node-' + index)?.classList.add('writeLine')
                        } else {
                            parsed.querySelector('.code ul .node-' + (index - 1))?.addEventListener('animationend', function () {
                                parsed.querySelector('.code ul .node-' + index)?.classList.add('writeLine')
                            })
                        }
                    }
                })
            }
        })
    }

    // Criar uma página de 404 com um botão voltar
    return <div className='error-container'>
        <div className='container'>
            <div className='error'>
                <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '0', gap: '20px' }}>
                    <h2>{props.codeMsg}</h2>
                    <h1>{props.code}</h1>
                </div>
                <p>{props.message}</p>
                {props.reset ? <div style={{ marginTop: '0px' }}>
                    <Button placeholder='Voltar' onClick={props.reset} />
                </div> : null}
            </div>
            <div className='stack-container'>
                <div className='card-container'>
                    <div className='perspec' style={{
                        '--spreaddist': '125px',
                        '--scaledist': '.75',
                        '--vertdist': '-25px'
                    } as React.CSSProperties}>
                        <div className='card'>
                            <div className='writing'>
                                <div className='topbar'>
                                    <div className='red'></div>
                                    <div className='yellow'></div>
                                    <div className='green'></div>
                                </div>
                                <div className='code'>
                                    <ul>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-container'>
                    <div className='perspec'
                        style={{
                            '--spreaddist': '100px',
                            '--scaledist': '.8',
                            '--vertdist': '-20px'
                        } as React.CSSProperties}>
                        <div className='card'>
                            <div className='writing'>
                                <div className='topbar'>
                                    <div className='red'></div>
                                    <div className='yellow'></div>
                                    <div className='green'></div>
                                </div>
                                <div className='code'>
                                    <ul>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-container'>
                    <div className='perspec' style={{
                        '--spreaddist': '75px',
                        '--scaledist': '.85',
                        '--vertdist': '-15px'
                    } as React.CSSProperties}>
                        <div className='card'>
                            <div className='writing'>
                                <div className='topbar'>
                                    <div className='red'></div>
                                    <div className='yellow'></div>
                                    <div className='green'></div>
                                </div>
                                <div className='code'>
                                    <ul>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-container'>
                    <div className='perspec' style={{
                        '--spreaddist': '50px',
                        '--scaledist': '.9',
                        '--vertdist': '-10px'
                    } as React.CSSProperties}>
                        <div className='card'>
                            <div className='writing'>
                                <div className='topbar'>
                                    <div className='red'></div>
                                    <div className='yellow'></div>
                                    <div className='green'></div>
                                </div>
                                <div className='code'>
                                    <ul>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-container'>
                    <div className='perspec' style={{
                        '--spreaddist': '25px',
                        '--scaledist': '.95',
                        '--vertdist': '-5px'
                    } as React.CSSProperties}>
                        <div className='card'>
                            <div className='writing'>
                                <div className='topbar'>
                                    <div className='red'></div>
                                    <div className='yellow'></div>
                                    <div className='green'></div>
                                </div>
                                <div className='code'>
                                    <ul>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-container'>
                    <div className='perspec' style={{
                        '--spreaddist': '0px',
                        '--scaledist': '1',
                        '--vertdist': '0px'
                    } as React.CSSProperties}>
                        <div className='card'>
                            <div className='writing'>
                                <div className='topbar'>
                                    <div className='red'></div>
                                    <div className='yellow'></div>
                                    <div className='green'></div>
                                </div>
                                <div className='code'>
                                    <ul>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

}